export default __webpack_public_path__ + "8a961de.png";